export default __webpack_public_path__ + "83409ffa21782ba2d0f60d372141377f.png";